import { render } from "./NotFound.vue?vue&type=template&id=3efdcea6"
const script = {}

import exportComponent from "C:\\Users\\quinn\\codebase\\personal-site-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__